import {
    CREATE_ORGANIZATION, CREATE_ORGANIZATION_SUCCESS,
    UPDATE_ORGANIZATION, UPDATE_ORGANIZATION_SUCCESS,
    DELETE_ORGANIZATION, DELETE_ORGANIZATION_SUCCESS,
    LIST_ORGANIZATIONS,
} from './OrganizationsActionTypes';
import { switchMap, map, catchError } from 'rxjs/operators';
import { combineEpics } from 'redux-observable';
import config from 'react-global-configuration';
import {organizationsActions} from './'
import {
    deleteWithAuth,
    errorHandlingWithLogoutCheck,
    getJsonWithAuth,
    postJsonWithAuth,
    putJsonWithAuth
} from "../../../components/AjaxHelpers";

export const organizationsEpics = combineEpics(

    // Events of type LIST_ORGANIZATIONS
    (action$, state$) => action$.ofType(LIST_ORGANIZATIONS).pipe(
        switchMap(action =>
            getJsonWithAuth({
                url: config.get('apiBaseUrl') + '/organizations/v1',
                state: state$.value
            }).pipe(
                map(payload => organizationsActions.listOrganizationsSucceeded(payload)),
                catchError(response => errorHandlingWithLogoutCheck(response, [organizationsActions.listOrganizationsFailed(response)]))
            )
        )
    ),

    (action$, state$) => action$.ofType(CREATE_ORGANIZATION).pipe(
        switchMap(action =>
            postJsonWithAuth({
                url: config.get('apiBaseUrl') + '/organizations/v1',
                body: {
                    name: action.organizationName,
                    contactName: action.contactName,
                    contactPhoneNumber: action.contactPhone,
                },
                state: state$.value
            }).pipe(
                map(payload => organizationsActions.createOrganizationSucceeded(payload)),
                catchError(response => errorHandlingWithLogoutCheck(response, [organizationsActions.createOrganizationFailed(response)]))
            )
        )
    ),

    (action$, state$) => action$.ofType(CREATE_ORGANIZATION_SUCCESS).pipe(
        map(action => organizationsActions.listOrganizations())
    ),


    (action$, state$) => action$.ofType(UPDATE_ORGANIZATION).pipe(
        switchMap(action =>
            putJsonWithAuth({
                url: config.get('apiBaseUrl') + '/organizations/v1/' + action.organizationId,
                body: {
                    organizationId: action.organizationId,
                    name: action.organizationName,
                    contactName: action.contactName,
                    contactPhoneNumber: action.contactPhone,
                },
                state: state$.value
            }).pipe(
                map(payload => organizationsActions.updateOrganizationSucceeded(payload)),
                catchError(response => errorHandlingWithLogoutCheck(response, [organizationsActions.updateOrganizationFailed(response)]))
            )
        )
    ),
    (action$, state$) => action$.ofType(UPDATE_ORGANIZATION_SUCCESS).pipe(
        map(action => organizationsActions.listOrganizations())
    ),

    (action$, state$) => action$.ofType(DELETE_ORGANIZATION).pipe(
        switchMap(action =>
            deleteWithAuth({
                url: config.get('apiBaseUrl') + '/organizations/v1/' + action.organizationId,
                state: state$.value
            }).pipe(
                map(payload => organizationsActions.deleteOrganizationSucceeded()),
                catchError(response => errorHandlingWithLogoutCheck(response, [organizationsActions.deleteOrganizationFailed(response)]))
            )
        )
    ),
    (action$, state$) => action$.ofType(DELETE_ORGANIZATION_SUCCESS).pipe(
        map(action => organizationsActions.listOrganizations())
    ),

);